import { useEffect, useState } from "react";
import { masterApi } from "@/contexts/MasterAuthContext";
import { Check, X, CreditCard } from "lucide-react";

const FEATURE_LABELS = {
    corporate_site: "Kurumsal Web Sitesi",
    custom_domain: "Özel Domain + SSL",
    panel_modules: "20+ Modül Panel Erişimi",
    ai_instagram_templates: "AI Instagram Şablonu",
    ai_credits_monthly: "Aylık AI Kredi",
    mackolik_sync: "Lig Verisi Sync",
    auto_standings: "Otomatik Puan Durumu",
    attendance: "Antrenman & Yoklama",
    finance: "Kulüp Maliyesi",
    ai_match_analysis: "AI Maç Analizi (DR AI Engine)",
    academy: "Akademi Yönetimi",
    auto_caption: "Otomatik Caption (DR AI)",
    priority_support: "Öncelikli Destek",
    training_session: "Özel Eğitim Seansı",
    club_data_entry: "Kulübünüzün veri girişi",
    player_data_entry: "Oyuncu veri girişi",
    early_access: "Gelecek özelliklere öncelikli erişim",
};

export default function MasterPlans() {
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        masterApi.get("/master/plans").then((r) => setPlans(r.data));
    }, []);

    const renderValue = (key, val) => {
        if (typeof val === "boolean") return val ? <Check size={16} className="text-emerald-400" /> : <X size={16} className="text-neutral-600" />;
        if (typeof val === "number") return <span className="text-yellow-400 font-mono">{val}</span>;
        return <span className="text-yellow-400 font-mono">{val}</span>;
    };

    return (
        <div data-testid="master-plans">
            <div className="mb-8">
                <div className="text-xs font-bold uppercase tracking-widest text-yellow-400 mb-2 flex items-center gap-2"><CreditCard size={14}/> Paketler</div>
                <h1 className="text-4xl font-extrabold tracking-tight">Abonelik Paketleri</h1>
                <p className="text-neutral-400 mt-2">DR AI FUTBOL'un sunduğu paket katalogu</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                {plans.map((p) => {
                    const highlighted = p.key === "plus";
                    return (
                        <div key={p.key} data-testid={`plan-card-${p.key}`} className={`bg-[#121212] border-2 rounded-2xl p-6 ${highlighted ? "border-yellow-500" : "border-[#2a2a2a]"}`}>
                            {highlighted && <div className="text-xs font-bold uppercase tracking-widest text-yellow-400 mb-3 text-center">★ En Popüler</div>}
                            <div className="text-2xl font-extrabold uppercase">{p.display_name}</div>
                            <div className="text-3xl font-extrabold mt-3">
                                <span className="text-yellow-400">₺{Number(p.monthly_price_try || 0).toLocaleString("tr-TR")}</span>
                                <span className="text-sm text-neutral-500"> /ay</span>
                            </div>
                            <div className="text-xs text-neutral-500 mt-1">{p.monthly_credit_limit} AI kredi / ay</div>
                            <div className="space-y-2.5 mt-6 text-sm">
                                {Object.entries(p.features || {}).map(([key, val]) => (
                                    <div key={key} className="flex items-center justify-between gap-3">
                                        <span className={`flex-1 ${val === false ? "text-neutral-600 line-through" : "text-neutral-200"}`}>{FEATURE_LABELS[key] || key}</span>
                                        {renderValue(key, val)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
